import React from "react";
import InvoiceList from "./InvoiceList";
export default function Invoices() { return <InvoiceList kind="invoice" />; }
